import { css } from '@emotion/react';
import FontWeights from '@polestar/component-warehouse-react/tokens/font-weights/FontWeights';
import FontStyles from '@polestar/component-warehouse-react/tokens/font-styles/FontStyles';
import Fonts from '@polestar/component-warehouse-react/tokens/fonts/Fonts';
import FontUnicodeRanges, { removeCommentsFromUnicodeRangesRegex, } from '@polestar/component-warehouse-react/tokens/font-unicode-ranges/FontUnicodeRanges';
export const createFontSrc = (domainOverride, type) => {
    const fontBase = `https://${domainOverride || `www.polestar.com`}/shared-assets/fonts/polestar-unica/`;
    return `url(${fontBase}${type}.woff2) format('woff2'), url(${fontBase}${type}.woff) format('woff')`;
};
export const createNewFontSrc = (domainOverride, script) => {
    const fontBase = `https://${domainOverride || `www.polestar.com`}/shared-assets/fonts/unica77/`;
    return `url(${fontBase}regular-${script}.woff2) format('woff2'), url(${fontBase}regular-${script}.woff) format('woff')`;
};
export const createFontFaceDefinition = ({ domainOverride, name, unicodeRange, customFontFamilyName, showFontName, }) => `${!!showFontName ? `/* ${name} */\n` : ''}@font-face {
  src: ${createNewFontSrc(domainOverride, name)};
  font-family: ${customFontFamilyName || Fonts.polestarUnicaName};
  font-weight: ${FontWeights.regular};
  font-style: ${FontStyles.normal};
  font-display: swap;
  unicode-range: '${unicodeRange.replace(removeCommentsFromUnicodeRangesRegex, '')}';
}
`;
const fonts = ({ domainOverride = '', newFont = false }) => !newFont
    ? css `
        @font-face {
          src: ${createFontSrc(domainOverride, 'regular')};
          font-family: ${Fonts.polestarUnicaName};
          font-weight: ${FontWeights.regular};
          font-style: ${FontStyles.normal};
          font-display: swap;
        }
      `
    : css `
        ${Object.keys(FontUnicodeRanges).map((item) => createFontFaceDefinition({
        name: item,
        domainOverride,
        unicodeRange: FontUnicodeRanges[item],
    }))}
      `;
export default (config) => {
    return fonts(config)
        .styles.replace(/(?:\r\n|\r|\n)/g, '')
        .replace(/\s\s+/g, ' ')
        .replace(';;;', ';')
        .replace(/};@font-face/gim, '}@font-face');
};
